export default __webpack_public_path__ + "static/media/menu.03a1094d.svg";